// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file modules/apiengine/services/reporting/reporting.proto (package aurora.core.apiengine.reportingv1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file modules/apiengine/services/reporting/reporting.proto.
 */
export const file_modules_apiengine_services_reporting_reporting: GenFile = /*@__PURE__*/
  fileDesc("CjRtb2R1bGVzL2FwaWVuZ2luZS9zZXJ2aWNlcy9yZXBvcnRpbmcvcmVwb3J0aW5nLnByb3RvEiFhdXJvcmEuY29yZS5hcGllbmdpbmUucmVwb3J0aW5ndjEiLwoZTGlzdENvbXBhbnlSZXBvcnRzUmVxdWVzdBISCgpjb21wYW55X2lkGAEgASgJIrQCChFDb21wYW55UmVwb3J0SXRlbRITCgtyZXBvcnRfdHlwZRgBIAEoCRITCgtyZXBvcnRfbmFtZRgCIAEoCRI7ChJsYXN0X2RlbGl2ZXJ5X3RpbWUYAyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESOwoSbGFzdF9kb3dubG9hZF90aW1lGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgBiAEBEh0KFWxhc3RfZGVsaXZlcnlfc3VjY2VzcxgFIAEoCBIbChNsYXN0X2RlbGl2ZXJ5X2Vycm9yGAYgASgJEhEKCXJlY3VycmluZxgHIAEoCEIVChNfbGFzdF9kZWxpdmVyeV90aW1lQhUKE19sYXN0X2Rvd25sb2FkX3RpbWUiYwoaTGlzdENvbXBhbnlSZXBvcnRzUmVzcG9uc2USRQoHcmVwb3J0cxgBIAMoCzI0LmF1cm9yYS5jb3JlLmFwaWVuZ2luZS5yZXBvcnRpbmd2MS5Db21wYW55UmVwb3J0SXRlbTKoAQoQUmVwb3J0aW5nU2VydmljZRKTAQoSTGlzdENvbXBhbnlSZXBvcnRzEjwuYXVyb3JhLmNvcmUuYXBpZW5naW5lLnJlcG9ydGluZ3YxLkxpc3RDb21wYW55UmVwb3J0c1JlcXVlc3QaPS5hdXJvcmEuY29yZS5hcGllbmdpbmUucmVwb3J0aW5ndjEuTGlzdENvbXBhbnlSZXBvcnRzUmVzcG9uc2UiAEJEWkJnaXRsYWIucHJ2YmwuY29tL2F1cm9yYS9jb3JlL3NyYy9tb2R1bGVzL2FwaWVuZ2luZS9hcGkvcmVwb3J0aW5ndjFiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * @generated from message aurora.core.apiengine.reportingv1.ListCompanyReportsRequest
 */
export type ListCompanyReportsRequest = Message<"aurora.core.apiengine.reportingv1.ListCompanyReportsRequest"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;
};

/**
 * Describes the message aurora.core.apiengine.reportingv1.ListCompanyReportsRequest.
 * Use `create(ListCompanyReportsRequestSchema)` to create a new message.
 */
export const ListCompanyReportsRequestSchema: GenMessage<ListCompanyReportsRequest> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_reporting_reporting, 0);

/**
 * @generated from message aurora.core.apiengine.reportingv1.CompanyReportItem
 */
export type CompanyReportItem = Message<"aurora.core.apiengine.reportingv1.CompanyReportItem"> & {
  /**
   * @generated from field: string report_type = 1;
   */
  reportType: string;

  /**
   * @generated from field: string report_name = 2;
   */
  reportName: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_delivery_time = 3;
   */
  lastDeliveryTime?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_download_time = 4;
   */
  lastDownloadTime?: Timestamp;

  /**
   * @generated from field: bool last_delivery_success = 5;
   */
  lastDeliverySuccess: boolean;

  /**
   * @generated from field: string last_delivery_error = 6;
   */
  lastDeliveryError: string;

  /**
   * @generated from field: bool recurring = 7;
   */
  recurring: boolean;
};

/**
 * Describes the message aurora.core.apiengine.reportingv1.CompanyReportItem.
 * Use `create(CompanyReportItemSchema)` to create a new message.
 */
export const CompanyReportItemSchema: GenMessage<CompanyReportItem> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_reporting_reporting, 1);

/**
 * @generated from message aurora.core.apiengine.reportingv1.ListCompanyReportsResponse
 */
export type ListCompanyReportsResponse = Message<"aurora.core.apiengine.reportingv1.ListCompanyReportsResponse"> & {
  /**
   * @generated from field: repeated aurora.core.apiengine.reportingv1.CompanyReportItem reports = 1;
   */
  reports: CompanyReportItem[];
};

/**
 * Describes the message aurora.core.apiengine.reportingv1.ListCompanyReportsResponse.
 * Use `create(ListCompanyReportsResponseSchema)` to create a new message.
 */
export const ListCompanyReportsResponseSchema: GenMessage<ListCompanyReportsResponse> = /*@__PURE__*/
  messageDesc(file_modules_apiengine_services_reporting_reporting, 2);

/**
 * @generated from service aurora.core.apiengine.reportingv1.ReportingService
 */
export const ReportingService: GenService<{
  /**
   * @generated from rpc aurora.core.apiengine.reportingv1.ReportingService.ListCompanyReports
   */
  listCompanyReports: {
    methodKind: "unary";
    input: typeof ListCompanyReportsRequestSchema;
    output: typeof ListCompanyReportsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_modules_apiengine_services_reporting_reporting, 0);

